import Head from "next/head";
import styles from "@/styles/Home.module.css";
import { ComponentTermConditions } from "@/components/ui/Screens";

const PageTermConditions = () => {
	return (
		<div className={styles.container}>
			<Head>
				<title>{"Terms & Conditions of Royal Air Charter Flights"}</title>
				<link rel="icon" href="/favicon.ico" />
				<link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
				<link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
				<link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
				<link rel="manifest" href="/site.webmanifest" />
				<link rel="mask-icon" href="/safari-pinned-tab.svg" color="#ffb11a" />
				<meta name="msapplication-TileColor" content="#da532c" />
				<meta name="theme-color" content="#ffffff" />
				<meta
					property="og:image"
					content="https://royal-air.s3.us-west-2.amazonaws.com/pub/royal-air-charter.jpg"
				></meta>
				<meta
					itemProp="thumbnailUrl"
					content="https://royal-air.s3.us-west-2.amazonaws.com/pub/royal-air-charter.jpg"
				/>
				<meta
					name="twitter:image"
					content="https://royal-air.s3.us-west-2.amazonaws.com/pub/royal-air-charter.jpg"
				></meta>
				<meta
					name="description"
					content="Read the terms for flying with Royal Air Charter. Our conditions cover cancellations, services, and all you need to know for a smooth journey."
				></meta>
			</Head>

			<main style={{ padding: 0, width: "100%" }}>
				<ComponentTermConditions />
			</main>
		</div>
	);
};

export default PageTermConditions;
